{
  "record_windows.schedule_unavailable": "Bu zamanlama artık mevcut değil",
  "record_windows.skip_occurrence_date": "{{date}} tarihindeki oluşumu atla",
  "record_windows.skip_occurrence": "Bu oluşumu atla",
  "record_windows.planned": "Planlanan",
  "record_windows.actual": "Gerçekleşen",
  "record_windows.open_source_routine": "Kaynak rutini aç"
}
